/**
 * API / client error strings. Same source as the worker — import MSG from
 * shared rather than inventing a second voice (docs/COPY.md §6).
 */
import { MSG } from "@vocifuchs/shared";

export const errors = {
  ...MSG,
  /** Alias used at every catch-all fallback. */
  failed: MSG.badRequest,
  pinMismatch: "Die PINs sind nicht gleich.",
  joinCodeLength: "Der Klassencode hat acht Zeichen.",
  /** No answer at all: no network, or the connection broke (issue #118). */
  offline: "Keine Verbindung. Versuch es nochmals, sobald du wieder Netz hast.",
} as const;
